// extracted by mini-css-extract-plugin
export default {"code":"CodeProcess_code__8Fy-p"};